import { useMemo } from "react";
import { Leaf, Snowflake } from "lucide-react";
import { useHoliday, THEME_STYLE } from "../../lib/holiday";

// Gentle falling leaves (Thanksgiving) or snow (Christmas). Decorative only.
export const HolidayFall = () => {
  const h = useHoliday();
  const flakes = useMemo(
    () => Array.from({ length: 16 }, (_, i) => ({
      left: (i * 6.3 + (i % 3) * 7) % 100,
      delay: (i * 1.7) % 12,
      dur: 11 + (i % 5) * 2.5,
      size: 14 + (i % 4) * 5,
      tone: i % 3,
    })),
    [],
  );
  if (!h) return null;
  const s = THEME_STYLE[h.active];
  const Icon = h.active === "christmas" ? Snowflake : Leaf;
  return (
    <div aria-hidden="true" data-testid="holiday-fall" className="holiday-fall pointer-events-none fixed inset-0 z-[40] overflow-hidden">
      {flakes.map((f, i) => (
        <span key={i} className="absolute top-[-40px]" style={{ left: `${f.left}%`, opacity: 0.7, animation: `holiday-fall ${f.dur}s linear ${f.delay}s infinite` }}>
          <Icon style={{ width: f.size, height: f.size, color: s.particles[f.tone] }} strokeWidth={1.75} />
        </span>
      ))}
    </div>
  );
};
